import { AttributeGroup, AttributeType, } from '../models';
import { tableRowsPerPageOptions } from '../constants';
export const PNS_DOCS_URL = 'https://docs.rezolve.com/docs/product-discovery-apis/part-number-search/';
export var AttributeField;
(function (AttributeField) {
    AttributeField["DisplayName"] = "displayName";
    AttributeField["DynamicFacetable"] = "dynamicFacetable";
    AttributeField["Indexable"] = "indexable";
    AttributeField["Searchable"] = "searchable";
    AttributeField["Filterable"] = "filterable";
    AttributeField["ExactMatch"] = "exactMatch";
    AttributeField["Retrievable"] = "retrievable";
    AttributeField["PartNumberSearchable"] = "partNumberSearchable";
    AttributeField["Metadata"] = "metadata";
    AttributeField["LastModifiedDate"] = "lastModifiedDate";
    AttributeField["LastModifiedField"] = "lastModifiedField";
    AttributeField["Type"] = "type";
    AttributeField["InUse"] = "inUse";
    AttributeField["LastUsed"] = "usageTime";
})(AttributeField || (AttributeField = {}));
export const systemInventoryAttributes = [
    'inventories.price',
    'inventories.original_price',
];
// BS-1064: Inventory/fulfillment attributes can't be boosted because the /facet endpoint
// doesn't support them (they require a place ID). Excluded from biasing attribute dropdown.
export const nonBoostableAttributes = [
    'customFulfillment1',
    'customFulfillment2',
    'customFulfillment3',
    'customFulfillment4',
    'customFulfillment5',
    'nextDayDelivery',
    'pickupInStore',
    'sameDayDelivery',
    'shipToStore',
];
export const DEFAULT_ATTRIBUTE_PAGE_DATA = {
    page: 1,
    perPage: tableRowsPerPageOptions[tableRowsPerPageOptions.length - 1],
    total: 0,
};
export const TAB_NAMES = [AttributeGroup.System, AttributeGroup.Custom, AttributeGroup.Inventory];
export const TAB_NAME_TO_COUNT_KEY = {
    [AttributeGroup.System]: 'system',
    [AttributeGroup.Custom]: 'custom',
    [AttributeGroup.Inventory]: 'inventories',
};
export const BOOL_WORDING_MAP = {
    true: 'YES',
    false: 'NO',
};
export const ATTRIBUTE_PENDING_TIME_MAP = {
    [AttributeField.Indexable]: 43200000, // 12 hours
    [AttributeField.Searchable]: 43200000,
    [AttributeField.Retrievable]: 43200000,
    [AttributeField.Filterable]: 172800000, // 48 hours
    [AttributeField.DynamicFacetable]: 172800000,
    [AttributeField.ExactMatch]: 172800000,
};
export const SYSTEM_ATTRIBUTE_PRODUCT_ID = 'productId';
export const ATTRIBUTE_TYPE_VARIANT_MAP = {
    [AttributeType.Textual]: 'variant_textual',
    [AttributeType.Numerical]: 'variant_numerical',
    [AttributeType.Unknown]: 'variant_unknown',
};
// We can use only these attributes, here is Google documentation - https://cloud.google.com/retail/docs/filter-recs#supported-fields
export const SYSTEM_ATTRIBUTES_LIST = [
    SYSTEM_ATTRIBUTE_PRODUCT_ID,
    'brands',
    'categories',
    'genders',
    'ageGroups',
    'colorFamilies',
    'colors',
    'sizes',
    'materials',
    'patterns',
    'conditions',
];
// default list that cannot be removed or re-ordered
export const DEFAULT_ATTRIBUTE_KEYS = ['brands', 'availability', 'price'];
export const ATTRIBUTES_VISIBILITY_LS_KEY = 'gbi:attributesVisibility';
export const ATTRIBUTES_VISIBILITY_SCOPE = {
    EVALUATION: 'evaluation',
    PREVIEW: 'preview',
};
